import { ICalendarBusyTime } from '../../../interfaces/scheduler_interfaces';
import { CalendarTimesModel } from '../models/calendar_times_model';
import { IDefineCommand, IQueryMediator, ICommand } from 'core-ts-types';
import { CalendarScheduledSectionServant } from '../servants/calendar_scheduled_section_servant';
import * as _4 from 'lodash4';
angular
  .module('capability-ng-scheduler')
  .service(
    'saveStudentUnavailabilityCommand',
    (
      defineCommandORM: IDefineCommand,
      $http: ng.IHttpService,
      calendarTimeFn: any,
      ngCalendarTimesModel: CalendarTimesModel,
      ngCalendarScheduledSectionServant: CalendarScheduledSectionServant,
      QueryMediator: IQueryMediator,
      $state: ng.ui.IStateService,
      getUnscheduledSectionsandAvailabilityCommand: ICommand,
      $stateParams: ng.ui.IStateParamsService
    ) => {
      return defineCommandORM('saveStudentUnavailabilityCommand', (deferred, termId, time) => {
        time = _4.isArray(time) ? _4.first(time) : time;

        if (!termId) {
          deferred.reject();
          return;
        }

        $http
          .post(`reg/preference/term/${termId}/unavailability/`, {
            timeslot: time
          })
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            time.id = data.id;
            const busyTimes = ngCalendarTimesModel.read().busy_times;
            const newTimes = ngCalendarScheduledSectionServant.buildUnavailableTimes([calendarTimeFn.importTime(time)]);
            ngCalendarTimesModel.write({
              busy_times: _4.concat(busyTimes, newTimes)
            });

            if ($state.is('my.schedule.registration.courseSections')) {
              const { sectionTypeId, courseId } = $stateParams;
              getUnscheduledSectionsandAvailabilityCommand(termId, courseId, sectionTypeId);
            }
            return deferred.resolve(data);
          })
          .catch(deferred.reject);
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/calendar/commands/save_student_unavailability_command.ts